import api from "./client";

export function getMyInmateAccess() {
  return api.get("/attorney/inmate-access");
}

export function requestInmateAccess(data) {
  return api.post("/attorney/inmate-access/request", data);
}

export function getAdminInmateAccess() {
  return api.get("/admin/inmate-access");
}

export function approveInmateAccess(id) {
  return api.post(`/admin/inmate-access/${id}/approve`);
}

export function rejectInmateAccess(id, reason) {
  return api.post(`/admin/inmate-access/${id}/reject`, { reason });
}

export function revokeInmateAccess(id, reason) {
  return api.post(`/admin/inmate-access/${id}/revoke`, { reason });
}
